import { logWrapper } from '../utils';
import diacritics from 'diacritics';

export default {
  additionalFieldModel: [
    'runtimeConstant',
    '$filter',
    function (runtimeConstant, $filter) {
      function AdditionalField(data) {
        this.id = data ? data.Id : 0;
        this.idCompany = data ? data.IdCompany : 0;
        this.idFieldType = data ? data.IdFieldType : 0;
        this.idList = data ? data.IdList : null;
        this.type =
          data && data.AdditionalFieldType ? data.AdditionalFieldType.Name : '';
        this.validationType =
          data && data.ValidationType ? data.ValidationType : 0;
        this.name = data ? data.Name : '';
        this.description = data ? data.Description : '';

        this.list = data ? data.List : null;

        this.selected = false;

        this.types = [
          { name: 'TRUE FALSE', id: 1 },
          { name: 'INTEGER', id: 2 },
          { name: 'TEXT', id: 3 },
          { name: 'DECIMAL', id: 4 },
          { name: 'LONG TEXT', id: 5 },
          { name: 'DATE', id: 6 },
          { name: 'LIST', id: 7 },
        ];

        this.validationTypes = [
          { name: 'NO VALIDATION', id: 0 },
          { name: 'CPF', id: 1 },
          { name: 'CNPJ', id: 2 },
        ];

        // Uses only on document type form
        this.required = false;
        this.itemFilterQuery = '';
      }

      function title() {
        return this.name;
      }

      function details() {
        return this.description;
      }

      function tags() {
        var fieldTypes = [
          'TRUE FALSE',
          'INTEGER',
          'TEXT',
          'DECIMAL',
          'LONG TEXT',
          'DATE',
          'LIST',
        ];
        var validationTypes = ['NO VALIDATION', 'CPF', 'CNPJ'];
        var tags = [fieldTypes[this.idFieldType - 1]];

        if (this.validationType) {
          tags.push(
            $filter('translate')('VALIDATION TYPE TAG') +
              validationTypes[this.validationType]
          );
        }

        if (this.list) {
          tags.push($filter('translate')('LIST TAG') + this.list.Name);
        }

        return tags;
      }

      function requiredProperty(value) {
        if (arguments.length > 0) {
          if (this.selected === false && value === true) {
            this.selected = true;
          }

          this.required = value;
        } else {
          return this.required;
        }
      }

      function isValid() {
        var isValid =
          this.name !== undefined &&
          this.name !== null &&
          this.name.trim() !== '';
        return isValid;
      }

      function typeProperty(value) {
        if (arguments.length) {
          this.idFieldType = value.id;
        } else {
          return this.types[this.idFieldType - 1];
        }
      }

      function validationTypeProperty(value) {
        if (arguments.length) {
          this.validationType = value.id;
        } else {
          return this.validationTypes[this.validationType];
        }
      }

      function listProperty(value) {
        if (arguments.length) {
          this.list = value;
          this.idList = value.id;
        } else {
          if (
            this.idList === undefined ||
            this.idList === null ||
            this.idList <= 0
          ) {
            return null;
          }
          var id = this.idList;
          var list = this.lists.filter(function (l) {
            return l.id === id;
          })[0];

          return list;
        }
      }

      function itemFilter(item, filter) {
        filter = diacritics.remove(filter).toLowerCase();
        return diacritics.remove(item).toLowerCase().indexOf(filter) > -1;
      }

      function run() {
        try {
          AdditionalField.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            requiredProperty: logWrapper(
              requiredProperty,
              runtimeConstant.isDebugModelsInternals
            ),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
            typeProperty: logWrapper(
              typeProperty,
              runtimeConstant.isDebugModelsInternals
            ),
            validationTypeProperty: logWrapper(
              validationTypeProperty,
              runtimeConstant.isDebugModelsInternals
            ),
            listProperty: logWrapper(
              listProperty,
              runtimeConstant.isDebugModelsInternals
            ),
            itemFilter: logWrapper(
              itemFilter,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return AdditionalField;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
